<template>
  <div class="flex flex-col">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Name
              </th>
            </tr>
            </thead>
            <tbody v-if="products">
            <tr
                :class="productIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                class="hover:bg-gray-100 cursor-pointer"
                @click="handleUpdateProduct(product)"
                v-for="(product, productIdx) in products"
                :key="product.id"
                >
              <td
                class="relative px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                <div v-if="!product.valid" class="absolute pl-3 left-0 flex items-center">
                  <Tooltip v-bind:msg="validationMessage(product)">
                    <ExclamationIcon class="h-5 w-5 text-yellow-400" aria-hidden="true" />
                  </Tooltip>
                </div>
                <div class="relative inset-y1 left-0 pl-3 flex items-center pointer-events-none">
                  {{ product.name }}
                </div>
              </td>


              <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                <button
                    @click.stop="() => { activeProduct = product; dangerModalIsOpen = true }"
                    class="text-red-500 hover:text-red-900">
                  Delete
                </button>

              </td>


            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <danger-modal
          :open="dangerModalIsOpen"
          title="Are you sure you want to destroy this product?"
          content="This action CANNOT be undone."
          cancel-button-text="Cancel"
          action-button-text="Destroy"
          v-on:modal:cancel="() => { dangerModalIsOpen = false; activeTemplate = null }"
          v-on:modal:perform="handleDeleteProduct"/>
    </div>
  </div>
</template>

<script>
import DangerModal from "@/components/Functional/Modal/DangerModal";
import { ExclamationIcon } from '@heroicons/vue/outline'
import Tooltip from "@/components/Functional/Tooltip"

export default {
  name: "ProductsTable",
  components: {
    DangerModal,
    ExclamationIcon,
    Tooltip,
  },
  props: [
    // "products",
    "clientId",
    "editCallback"
  ],
  data() {
    return {
      dangerModalIsOpen: false,
      activeProduct: null

    }
  },

  methods: {
    async handleUpdateProduct(product) {
      this.$store.dispatch('showLoadingSpinner')

      try {
        await this.$store.dispatch('getProduct', product)
      } catch (e) {
       this.$store.dispatch('createAlert', {
         type: 'danger',
         message: e
       })
      }
      try {
        await this.$store.dispatch('openUpdateProductPanel')
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
      this.$store.dispatch('hideLoadingSpinner')

    },
    async handleDeleteProduct() {
      this.$store.dispatch('showLoadingSpinner')

      try {
        await this.$store.dispatch('deleteProduct', this.activeProduct)
        this.$store.dispatch('createAlert', {
          type: 'success',
          message: 'Product Successfully Deleted'
        })
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
        this.dangerModalIsOpen = false
        this.activeProduct = null
        this.$store.dispatch('hideLoadingSpinner')
      }
      this.dangerModalIsOpen = false
      this.activeProduct = null
      this.$store.dispatch('hideLoadingSpinner')
    },
    validationMessage(product) {
      if (product.validationMessages) {
        return product.validationMessages.join("\n")
      } else {
        return ''
      }
    },
  },
  computed: {
    products() {
      return this.$store.getters.getProducts
    }
  }

}
</script>

<style scoped>

</style>
